import _noop from 'lodash/noop'
import { useEffect, useState } from 'react'

export const useScrollPosition = ({ ref, options: { position = 'scrollTop' } = {} }) => {
    const [scrollPosition, setScrollPosition] = useState(0)

    useEffect(() => {
        const element = ref.current
        if (!element) return _noop

        const trackScrollPosition = (event) => {
            setScrollPosition(event.target[position])
        }
        const options = { passive: true }

        element.addEventListener('scroll', trackScrollPosition, options)
        return () => {
            element.removeEventListener('scroll', trackScrollPosition, options)
        }
    }, [position, ref])

    return { scrollPosition }
}
